export default __webpack_public_path__ + "static/media/Spot2.9fd095f7.mp4";